import { settings } from '../settings'

export default {
  root: {
    color: `${settings.theme.palette.primary.main}`,
    fontSize: '14px',
  },
}
